module.exports = __webpack_public_path__ + "static/media/menu_announcement_default.dc2a9bdc.svg";